<template>
    <!--Header v-if="!isFullPageView"></Header>-->

    <router-view v-slot="{ Component }">
        <transition
            name="fade"
            mode="out-in">
            <main
                class="main"
                :class="{ 'main_full-page': this.isFullPageView }">
                <component :is="Component"></component>
            </main>
        </transition>
    </router-view>
</template>

<script>
  import Header from "@/components/common/Header.vue";

  export default {
    name: "App",

    components: {
      Header
    },

    computed: {
      isAuthenticationView () {
        return this.$route.name === "SignIn";
      },

      isPage404View () {
        return this.$route.name === "PageNotFound";
      },

      isFullPageView () {
        return this.isAuthenticationView || this.isPage404View;
      }
    }
  };
</script>

<style lang="scss">
</style>
